import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ApiClient,
  PaymentInfo,
  PaymentMethodInfo,
  PaymentSummary,
  RecordManualPaymentRequest,
} from '../sdk/sdk';

@Injectable({ providedIn: 'root' })
export class PaymentService {
  private readonly sdk = inject(ApiClient);

  getManualPaymentMethods(): Observable<PaymentMethodInfo[]> {
    return this.sdk.getManualPaymentMethods();
  }

  recordManualPayment(request: RecordManualPaymentRequest): Observable<PaymentInfo> {
    return this.sdk.recordManualPayment(request);
  }

  getPaymentSummary(opportunityId: string): Observable<PaymentSummary> {
    return this.sdk.getPaymentSummary(opportunityId);
  }
}
